import { render, staticRenderFns } from "./Followings.vue?vue&type=template&id=e4edc208&"
import script from "./Followings.vue?vue&type=script&lang=js&"
export * from "./Followings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports